export const focusScreenreaderOnElement = (
    element: HTMLElement,
    triggerElement?: HTMLElement | null,
) => {
    // if the trigger element is not focused, do nothing
    // this is to prevent the focus from being shifted
    // when the user is already interacting with the form
    if (triggerElement !== document.activeElement) {
        return;
    }

    // temporarily set the tabindex to -1 to allow for focus
    const prevTabIndex = element.getAttribute('tabindex');

    element.setAttribute('tabindex', '-1');
    element.focus();

    // reset the tabindex after a short delay to allow the
    // focus to shift
    setTimeout(() => {
        if (prevTabIndex) {
            element.setAttribute('tabindex', prevTabIndex);
        } else {
            element.removeAttribute('tabindex');
        }
    }, 10);
};
